.ux-iws-nb-teaser-product {
    box-sizing: border-box;
    display: block;
    width: 100%;

    @media (min-width: 768px) {
        padding: 15px;
    }

    ux-button {
        --ux-button-primary-text-color: #fff;
        --ux-button-primary-bg-color: #285172;
        --ux-button-primary-border-color: #fff;
        --ux-button-primary-hover-text-color: #285172;
        --ux-button-primary-hover-bg-color: transparent;
        --ux-button-primary-hover-border-color: #285172;
        --ux-button-primary-focus-border-color: #285172;
        --ux-button-transition: none;
        --ux-button-primary-disabled-bg-color: #80a0b4;
        --ux-button-primary-disabled-border-color: #fff;
        --ux-button-primary-disabled-text-color: #fff;
    }

    &__grid {
        display: grid;
        gap: 30px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image"
            "header"
            "tags"
            "description"
            "features"
            "cta";
    }

    .ux-iws-nb-teaser-product__image {
        grid-area: image;
    }

    .ux-iws-nb-teaser-product__header {
        grid-area: header;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
    }

    .ux-iws-nb-teaser-product__tags {
        grid-area: tags;
        display: inline-flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        margin: 0;
    }

    .ux-iws-nb-teaser-product__description {
        grid-area: description;
    }

    .ux-iws-nb-teaser-product__features {
        grid-area: features;
    }

    .ux-iws-nb-teaser-product__cta {
        grid-area: cta;
    }

    &__image img {
        display: block;
        width: 100%;
        max-width: 100%;
        aspect-ratio: 3 / 2;
        object-fit: cover;
    }

    &__header h2,
    &__header h3,
    &__header h4 {
        line-height: 1.2;
        margin: 0 0 10px;
    }

    &__header p {
        line-height: 1.2;
        margin: 0;
    }

    &__tag {
        background-color: $color-blue-6;
        color: $color-blue-1;
        padding: 4px 8px;
        @include font(bold);
        font-size: $size-text-smaller;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    &__tag--highlighted {
        background-color: $color-blue-1;
        color: $color-white;
    }

    &__tag--unsupported {
        opacity: 0.2;
    }

    &__description p {
        @include font(normal);
        font-size: 14px;
        line-height: 1.2;
        margin: 0;
    }

    &__features ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin: 0;
        padding: 0;
        gap: 10px;
    }

    &__features li {
        list-style: square outside;
        font-size: 14px;
        line-height: 1.2;
        margin: 0 0 0 14px;
        padding: 0;
    }

    /* TODO: provide class globally */
    .visually-hidden {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
}

@media (max-width: 567px) {
    ux-button {
        width: 100%;
        flex: 1 0 100%;
    }
}

@media (max-width: 767px) {
    .ux-iws-nb-teaser-product__image img {
        width: auto;
        max-height: 320px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .ux-iws-nb-teaser-product__image img {
        width: auto;
        max-height: 400px;
    }
}

@media (min-width: 768px) {
    .ux-iws-nb-teaser-product__grid {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image image"
            "header header"
            "tags tags"
            "description features"
            "cta cta";
    }

    .ux-iws-nb-teaser-product__features {
        border-left: 1px solid $color-black;
        padding-left: 10px;
    }
}

@media (min-width: 1024px) {
    .ux-iws-nb-teaser-product__grid {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image header"
            "image tags"
            "image ."
            "description features"
            "cta features";
    }
}

@media (min-width: 1440px) {
    .ux-iws-nb-teaser-product__features ul {
        grid-template-columns: 1fr;
    }

    .ux-iws-nb-teaser-product__grid {
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto auto auto max-content;
        grid-template-areas:
            "image header header"
            "image tags tags"
            "image description features"
            "image cta features";
    }
}

@media (min-width: 1800px) {
    .ux-iws-nb-teaser-product__tags,
    .ux-iws-nb-teaser-product__description,
    .ux-iws-nb-teaser-product__cta {
        padding-left: 30px;
    }
}
